import React from "react";

import { cn } from "@/lib/utils";

interface SkillCollectionEmptySelectionCardProps {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  compact?: boolean;
  stretch?: boolean;
}

export const SkillCollectionEmptySelectionCard = ({
  children,
  icon,
  title,
  description,
  action,
  className,
  contentClassName,
  compact = false,
  stretch = true,
}: SkillCollectionEmptySelectionCardProps) => (
  <div
    className={cn(
      "flex w-full items-center justify-center",
      stretch ? "h-full min-h-0 flex-1 p-8" : "p-0",
      className,
    )}
  >
    <div
      className={cn(
        "w-full border border-gray-200/80 bg-white text-center shadow-sm shadow-gray-950/5",
        compact ? "max-w-none rounded-2xl px-4 py-5" : "max-w-xl rounded-3xl px-6 py-8",
        contentClassName,
      )}
    >
      {children ?? (
        <div className="flex flex-col items-center text-center">
          {icon && (
            <div
              className={cn(
                "flex items-center justify-center rounded-full bg-gray-100 text-gray-400",
                compact ? "mb-3 h-11 w-11" : "mb-4 h-12 w-12",
              )}
            >
              {icon}
            </div>
          )}
          {title && <p className="text-base font-medium text-gray-900">{title}</p>}
          {description && (
            <p
              className={cn(
                "text-sm leading-6 text-gray-500",
                compact ? "mt-1.5 max-w-xs" : "mt-2 max-w-md",
              )}
            >
              {description}
            </p>
          )}
          {action && <div className={compact ? "mt-3 w-full" : "mt-4 w-full"}>{action}</div>}
        </div>
      )}
    </div>
  </div>
);
